import React from "react"

const cx = (...classes) => classes.filter(Boolean).join(" ")

const variantClassNames = {
  accent: "ui-badge--accent",
  outline: "ui-badge--outline",
  subtle: "ui-badge--subtle",
}

const sizeClassNames = {
  xl: "ui-badge--xl",
}

export function Badge({
  variant = "subtle",
  size = "md",
  className,
  children,
  ...props
}) {
  return (
    <span
      className={cx(
        "ui-badge",
        variantClassNames[variant] || "",
        sizeClassNames[size] || "",
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}
